import { useNavigate } from 'react-router-dom';
import type { BulkUploadResponse } from '../../../types';
import type { NewCategoryInfo } from '../types';

interface ResultStepProps {
  fileName: string;
  result: BulkUploadResponse['result'];
  newCategories: NewCategoryInfo[];
  onUploadAnother: () => void;
}

export const ResultStep: React.FC<ResultStepProps> = ({
  fileName,
  result,
  newCategories,
  onUploadAnother,
}) => {
  const navigate = useNavigate();

  return (
    <div>
      <div className="mb-6 rounded-xl border border-green-200 bg-green-50 p-6 text-center">
        <h3 className="text-lg font-semibold text-green-700">一括登録が完了しました</h3>
        <p className="mt-1 text-sm text-gray-500">{fileName}</p>
      </div>

      <div className="mb-6 grid grid-cols-2 gap-4">
        <div className="rounded-lg border border-gray-200 p-4">
          <h4 className="mb-3 font-medium text-gray-700">FAQ</h4>
          <div className="space-y-2 text-sm">
            <div className="flex justify-between">
              <span className="text-gray-500">新規追加</span>
              <span className="font-semibold text-blue-600">{result.faqsAdded}件</span>
            </div>
            <div className="flex justify-between">
              <span className="text-gray-500">上書き更新</span>
              <span className="font-semibold text-yellow-600">{result.faqsUpdated}件</span>
            </div>
            <div className="flex justify-between">
              <span className="text-gray-500">スキップ</span>
              <span className="font-semibold text-gray-400">{result.faqsSkipped}件</span>
            </div>
          </div>
        </div>
        <div className="rounded-lg border border-gray-200 p-4">
          <h4 className="mb-3 font-medium text-gray-700">症状</h4>
          <div className="space-y-2 text-sm">
            <div className="flex justify-between">
              <span className="text-gray-500">新規追加</span>
              <span className="font-semibold text-blue-600">{result.symptomsAdded}件</span>
            </div>
            <div className="flex justify-between">
              <span className="text-gray-500">上書き更新</span>
              <span className="font-semibold text-yellow-600">{result.symptomsUpdated}件</span>
            </div>
            <div className="flex justify-between">
              <span className="text-gray-500">スキップ</span>
              <span className="font-semibold text-gray-400">{result.symptomsSkipped}件</span>
            </div>
          </div>
        </div>
      </div>

      {newCategories.length > 0 && (
        <div className="mb-6 rounded-lg border border-green-200 bg-green-50 p-4">
          <h4 className="mb-2 font-medium text-green-700">
            新規作成されたカテゴリ ({result.categoriesCreated}件)
          </h4>
          <div className="flex flex-wrap gap-2 text-sm">
            {newCategories.map((cat) => (
              <span
                key={`${cat.type}-${cat.name}`}
                className="rounded-md border border-green-200 bg-white px-3 py-1"
              >
                {cat.type === 'faq' && cat.productCategoryName
                  ? `${cat.productCategoryName} > ${cat.name}`
                  : cat.name}
              </span>
            ))}
          </div>
        </div>
      )}

      <div className="flex justify-center gap-3 pt-2">
        <button
          onClick={() => navigate('/faq')}
          className="rounded-lg border border-gray-300 px-6 py-2.5 text-sm hover:bg-gray-50"
        >
          FAQ一覧を確認
        </button>
        <button
          onClick={() => navigate('/symptoms')}
          className="rounded-lg border border-gray-300 px-6 py-2.5 text-sm hover:bg-gray-50"
        >
          症状一覧を確認
        </button>
        <button
          onClick={onUploadAnother}
          className="rounded-lg bg-blue-600 px-6 py-2.5 text-sm font-medium text-white hover:bg-blue-700"
        >
          続けてアップロード
        </button>
      </div>
    </div>
  );
};
